import React, { memo } from 'react';
import { useTheme } from 'styled-components';
import { NamePath } from '@xbcb/ui-types';
import { Select, FormItem } from '@xbcb/form-item-components';
import { selectFilter, getCodes } from '@xbcb/ui-utils';
import get from 'lodash/get';

export interface StateOrProvinceSelectProps {
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  label: string;
  localNamePath: NamePath;
  codesPath: string;
}

const StateOrProvinceSelect = ({
  disabled,
  readOnly,
  required,
  label,
  localNamePath,
  codesPath,
}: StateOrProvinceSelectProps) => {
  const theme = useTheme();
  const provinceCodes = get(getCodes(), codesPath);
  const provinceOptions = Object.keys(provinceCodes).map((provinceCode) => ({
    value: provinceCode,
    label: provinceCodes[provinceCode].name,
  }));

  return (
    <FormItem
      label={label}
      $itemSize={theme.size.tiny_short}
      name={localNamePath}
      rules={[{ required, message: ' ' }]}
      $readOnly={readOnly}
    >
      <Select
        disabled={disabled}
        showSearch
        filterOption={selectFilter}
        notFoundContent="None Found"
        dropdownMatchSelectWidth={false}
        options={provinceOptions}
      />
    </FormItem>
  );
};

export default memo(StateOrProvinceSelect);
